import { useState, useEffect } from "react";
import { getHistoryActivity } from "../../../services/container";
/**
 * Hook pour charger les données d'historique d'activité
 */
export const useActivityHistoryData = (
  keywordFilter,
  periodHistoryStart,
  periodHistoryStop,
  displayAnomaly,
  handleValidate,
  setOpenFilter = null,
) => {
  const [isLoading, setIsLoading] = useState(true);
  const [dataHistoryContainer, setDataHistoryContainer] = useState([]);
  const [countDataHistory, setCountDataHistory] = useState(0);
  const [fullData, setFullData] = useState([]);

  useEffect(
    () => {
      setIsLoading(true);
      if (setOpenFilter) {
        setOpenFilter(false);
      }
      const fetchData = async () => {
        const keywordValue =
          keywordFilter && keywordFilter.value
            ? keywordFilter.value
            : Array.isArray(keywordFilter)
              ? keywordFilter
              : [];

        const response = await getHistoryActivity({
          periodStart: periodHistoryStart,
          periodStop: periodHistoryStop,
          displayAnomalie: displayAnomaly,
          keywordFilter: JSON.stringify(keywordValue),
          toDownload: true,
        });
        if (response.status === 200) {
          setDataHistoryContainer(response.data.historyList);
          setFullData(response.data.historyList);
          if (response.data.historyList) {
            setCountDataHistory(response.data.historyList.length);
          }
          setIsLoading(false);
        }
      };

      fetchData();
    },
    // eslint-disable-next-line
    [
      handleValidate,
      keywordFilter,
      periodHistoryStart,
      periodHistoryStop,
      displayAnomaly,
    ],
  );

  useEffect(() => {
    if (fullData.length > 0) {
      if (displayAnomaly) {
        const filteredData = fullData.filter(
          (timeLine) => timeLine.anomalies > 0,
        );
        setDataHistoryContainer(filteredData);
        setCountDataHistory(filteredData.length);
      } else {
        setDataHistoryContainer(fullData);
        setCountDataHistory(fullData.length);
      }
    }
  }, [displayAnomaly, fullData]);

  return {
    isLoading,
    dataHistoryContainer,
    countDataHistory,
    fullData,
  };
};
